import {
  type FlowAlertRuleCreateBodyInput,
  type FlowAlertRuleListQueryInput,
  type FlowAlertRuleUpdateBody,
} from 'flow-schema';

import { type Common } from '../common.js';
import { type FlowAlertRule } from '../models/flow/flowAlertRule.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-alert-rules';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowAlertRuleListQueryInput): Promise<FlowAlertRule[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async create(values: FlowAlertRuleCreateBodyInput): Promise<FlowAlertRule> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: FlowAlertRuleUpdateBody): Promise<FlowAlertRule> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<FlowAlertRule> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
